import { isNil } from 'lodash-es';

export function isNilOrEmpty(value: string): boolean {
  return isNil(value) || value === '';
}
